import { useSendProfileReminderMutation } from "@/features/people/graphql/generated";
import { useToast } from "@/shared/contexts/toast.context";

export const useRemindPeople = () => {
  const [sendProfileReminder] = useSendProfileReminderMutation();
  const { showToast } = useToast();

  const handleSendProfileReminder = async (personId: number) => {
    const result = await sendProfileReminder({ variables: { personId } });
    if (result.data?.sendProfileReminder) {
      showToast({
        type: "success",
        message: "Profile reminder sent successfully",
      });
    }
  };

  return {
    handleSendProfileReminder,
  };
};
